// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---pages-home-mdx": () => import("./../../../../pages/home.mdx" /* webpackChunkName: "component---pages-home-mdx" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

